// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/5e405b2bd82a29d40231.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"8beab056ed4dba465dee","179":"d8ffe93fc7116060ae42","180":"9eae27cd5196ae1d448b"}[chunkId] + ".chunk.js";
};